import React from 'react';
import { SuperAdminLayout } from './SuperAdminLayout';
import { IntegrationApisPanel } from '../../components/admin/IntegrationApisPanel';

const SuperAdminIntegrations = () => (
  <SuperAdminLayout>
    <IntegrationApisPanel variant="dark" />
  </SuperAdminLayout>
);

export default SuperAdminIntegrations;
